import { cn, Icon, Typography } from "@kyan/ui";
import Image from "next/image";

const skins = ["pepe-cool", "cat-cool", "cat-sad", "pepe-sad"];

interface PnLCardGeneratorSkinSelectorProps {
  selectedSkin: string | null;
  setSelectedSkin: (skin: string | null) => void;
}

export const PnLCardGeneratorSkinSelector: React.FC<
  PnLCardGeneratorSkinSelectorProps
> = ({ selectedSkin, setSelectedSkin }) => {
  return (
    <>
      <Typography variant="secondary">Add skin</Typography>
      <div className="flex items-center gap-2">
        <button
          className={cn("size-10 rounded-sm bg-white/20", {
            "border-primary rounded-sm border": selectedSkin === null,
          })}
          onClick={() => {
            setSelectedSkin(null);
          }}
        >
          <Icon name="error-circle" className="dark:text-white" />
        </button>
        {skins.map((skin) => (
          <button
            key={skin}
            className={cn(
              "size-10 cursor-pointer rounded-sm border border-white dark:border-black",
              {
                "!border-primary": selectedSkin === skin,
              },
            )}
            onClick={() => {
              setSelectedSkin(skin);
            }}
          >
            <Image
              alt={skin}
              width={40}
              height={40}
              src={`/images/pnl-card/${skin}.svg`}
            />
          </button>
        ))}
      </div>
    </>
  );
};
